import React from 'react';
import PropTypes from 'prop-types';

import {useSidebarContext} from '../../../../utility/AppContextProvider/SidebarContextProvider';

import './index.style.less';

const AppLogo = ({hasSidebarColor}) => {
  const {sidebarColorSet} = useSidebarContext();
  return (
    <div className='app-logo'>
      {hasSidebarColor && sidebarColorSet.mode === 'dark' ? (
        <img
          src={process.env.PUBLIC_URL + '/assets/images/LogoLaju.svg'}
          alt='mandiri-logo'
        />
      ) : (
        <img
          src={process.env.PUBLIC_URL + '/assets/images/LogoLaju.svg'}
          alt='mandiri-logo'
        />
      )}
    </div>
  );
};

export default AppLogo;

AppLogo.propTypes = {
  hasSidebarColor: PropTypes.bool,
};
